import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="header__section">
      <div className="main__header header__sticky">
        <div className="container-fluid">
          <div className="main__header--inner position__relative d-flex justify-content-between align-items-center">
            <div className="main__logo">
              <h1 className="main__logo--title">
                <Link className="main__logo--link" to="/">
                  <img
                    className="main__logo--img "
                    src="/assets/img/logo/nav-log.webp"
                    alt="logo-img"
                  />
                </Link>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
